module.exports = __webpack_public_path__ + "img/grey-mountains.8f3fd9d9.svg";